import { formatCAD } from '../lib/decimal';

interface PenaltyBannerProps {
  /** Cents-string of the current TFSA excess (over-contribution). */
  excess_cents: string;
  /** Cents-string of accumulated CRA penalty so far. */
  penalty_cents: string;
  /** Whole months the excess has been in the account. */
  months_over: number;
}

/**
 * Running over-contribution penalty banner (P0-1).
 *
 * Banner copy is LOCKED — approved by Mo 2026-05-11 in
 * workflows/tier1-fix-plan-v1.md. Do not paraphrase.
 *
 * Brand: alert-red bg per @reference/brand-standards.md. Grain-gold is
 * NOT used here — Gold is reserved for editable cells.
 *
 * Caller decides whether to render this banner; the component itself
 * always renders the locked copy when given inputs.
 */
export function PenaltyBanner({
  excess_cents,
  penalty_cents,
  months_over,
}: PenaltyBannerProps) {
  const excessStr = formatCAD(excess_cents);
  const penaltyStr = formatCAD(penalty_cents);

  return (
    <div
      role="alert"
      class="flex items-start gap-2 rounded-lg px-3 py-2 text-sm bg-alert-red text-white font-medium border border-alert-red"
    >
      <span aria-hidden="true" class="shrink-0 mt-0.5 font-bold">⚠</span>
      <span>
        You're over your TFSA limit by {excessStr}. CRA penalty so far:{' '}
        {penaltyStr} ({months_over} months × 1% × {excessStr}). Withdraw the
        excess to stop the penalty.
      </span>
    </div>
  );
}
